import { jsxs as Xe, Fragment as Ye, jsx as i } from "react/jsx-runtime";
import { useState as Ze, useCallback as ts, useEffect as ke } from "react";
import { ProgramAirdate as os } from "../components/ProgramAirdate/ProgramAirdate.js";
import { Loading as as } from "../components/Loading/Loading.js";
import { ResponsiveImage as ms } from "../components/ResponsiveImage/ResponsiveImage.js";
import { ErrorHandler as cs } from "../components/ErrorHandler/ErrorHandler.js";
import { getOnNowProgram as ns } from "../utils/getOnNowProgram.js";
function Ss({
  scheduleEndpoint: r,
  network: t,
  fallbackImage: o,
  getResource: a,
  showEpisodeNumber: m = !1,
  ProgramAirdateProps: es = {
    brand: "Grit",
    buttonStyle: "flat",
    logoStyle: "image",
    useLogo: !1,
    useSeriesColors: !0,
    href: "/schedule"
  }
}) {
  var d, l, p, g, u, x, f, S, h, z, w, y, $, v, P, _, C, b, N, j, A, L, O, T, q, E, F, G, H, U, B, D, I, J, K, M, Q, R, V, W, X, Y, Z, k, ee, se, ie, re, te, oe, ae, me, ce, ne, de, le, pe, ge, ue, xe, fe, Se, he, ze, we, ye, $e, ve, Pe, _e, Ce, be, Ne, je, Ae, Le, Oe, Te, qe, Ee, Fe, Ge, He, Ue, Be, De, Ie, Je, Ke, Me, Qe, Re, Ve;
  const [e, ss] = Ze(null), [is, rs] = Ze("on-now"), c = document.querySelector(":root"), n = ts(() => {
    (async () => {
      const s = await ns({
        scheduleEndpoint: r,
        network: t,
        showEpisodeNumber: m,
        fallbackImage: o,
        getResource: a
      });
      ss(s == null ? void 0 : s.program), rs(s == null ? void 0 : s.type);
    })();
  }, [r, t, m, o, a]);
  return ke(() => n(), [n]), ke(() => {
    var s, We;
    e !== null && c.style.setProperty("--on-now-text-color", ((We = (s = e == null ? void 0 : e.episode) == null ? void 0 : s.series) == null ? void 0 : We.primary_color) || "var(--theme-color-100)");
  }, [e, c]), /* @__PURE__ */ Xe(Ye, { children: [
    e === void 0 && /* @__PURE__ */ i("div", { style: { gridColumn: "1/span 2" }, children: /* @__PURE__ */ i(
      cs,
      {
        title: "An error has been encounter.",
        message: "There has been an error while retrieving our currently airing program."
      }
    ) }),
    e === null && /* @__PURE__ */ i(as, { topOffset: "30%" }),
    e != null && /* @__PURE__ */ Xe(Ye, { children: [
      /* @__PURE__ */ i(os, { ...es, type: is, program: e }),
      /* @__PURE__ */ i("div", { className: "program-on-now__image-wrapper", children: ((p = (l = (d = e == null ? void 0 : e.episode) == null ? void 0 : d.series) == null ? void 0 : l.image) == null ? void 0 : p.sizes) === void 0 ? /* @__PURE__ */ i("img", { className: "on-now__series-img", src: (x = (u = (g = e.episode) == null ? void 0 : g.series) == null ? void 0 : u.image) == null ? void 0 : x.url, alt: "" }) : /* @__PURE__ */ i(
        ms,
        {
          fullSizeUrl: (h = (S = (f = e == null ? void 0 : e.episode) == null ? void 0 : f.series) == null ? void 0 : S.image) == null ? void 0 : h.url,
          sources: [
            {
              media: "min-width: 2000px",
              srcsets: [`${(_ = (P = (v = ($ = (y = (w = (z = e.episode) == null ? void 0 : z.series) == null ? void 0 : w.image) == null ? void 0 : y.sizes) == null ? void 0 : $[0]) == null ? void 0 : v.srcSets) == null ? void 0 : P[3]) == null ? void 0 : _.src} 1x`, `${(O = (L = (A = (j = (N = (b = (C = e.episode) == null ? void 0 : C.series) == null ? void 0 : b.image) == null ? void 0 : N.sizes) == null ? void 0 : j[0]) == null ? void 0 : A.srcSets) == null ? void 0 : L[5]) == null ? void 0 : O.src} 2x`]
            },
            {
              media: "min-width: 1425px",
              srcsets: [`${(U = (H = (G = (F = (E = (q = (T = e.episode) == null ? void 0 : T.series) == null ? void 0 : q.image) == null ? void 0 : E.sizes) == null ? void 0 : F[0]) == null ? void 0 : G.srcSets) == null ? void 0 : H[2]) == null ? void 0 : U.src}`, `${(Q = (M = (K = (J = (I = (D = (B = e.episode) == null ? void 0 : B.series) == null ? void 0 : D.image) == null ? void 0 : I.sizes) == null ? void 0 : J[0]) == null ? void 0 : K.srcSets) == null ? void 0 : M[5]) == null ? void 0 : Q.src} 2x`]
            },
            {
              media: "min-width: 960px",
              srcsets: [`${(k = (Z = (Y = (X = (W = (V = (R = e.episode) == null ? void 0 : R.series) == null ? void 0 : V.image) == null ? void 0 : W.sizes) == null ? void 0 : X[0]) == null ? void 0 : Y.srcSets) == null ? void 0 : Z[1]) == null ? void 0 : k.src}`, `${(ae = (oe = (te = (re = (ie = (se = (ee = e.episode) == null ? void 0 : ee.series) == null ? void 0 : se.image) == null ? void 0 : ie.sizes) == null ? void 0 : re[0]) == null ? void 0 : te.srcSets) == null ? void 0 : oe[3]) == null ? void 0 : ae.src} 2x`]
            },
            {
              media: "min-width: 600px",
              srcsets: [`${(ge = (pe = (le = (de = (ne = (ce = (me = e.episode) == null ? void 0 : me.series) == null ? void 0 : ce.image) == null ? void 0 : ne.sizes) == null ? void 0 : de[0]) == null ? void 0 : le.srcSets) == null ? void 0 : pe[2]) == null ? void 0 : ge.src}`, `${(we = (ze = (he = (Se = (fe = (xe = (ue = e.episode) == null ? void 0 : ue.series) == null ? void 0 : xe.image) == null ? void 0 : fe.sizes) == null ? void 0 : Se[0]) == null ? void 0 : he.srcSets) == null ? void 0 : ze[5]) == null ? void 0 : we.src} 2x`]
            },
            {
              media: "min-width: 300px",
              srcsets: [`${(be = (Ce = (_e = (Pe = (ve = ($e = (ye = e.episode) == null ? void 0 : ye.series) == null ? void 0 : $e.image) == null ? void 0 : ve.sizes) == null ? void 0 : Pe[0]) == null ? void 0 : _e.srcSets) == null ? void 0 : Ce[1]) == null ? void 0 : be.src} 1x`, `${(qe = (Te = (Oe = (Le = (Ae = (je = (Ne = e.episode) == null ? void 0 : Ne.series) == null ? void 0 : je.image) == null ? void 0 : Ae.sizes) == null ? void 0 : Le[0]) == null ? void 0 : Oe.srcSets) == null ? void 0 : Te[3]) == null ? void 0 : qe.src} 2x`]
            },
            {
              media: "min-width: 1px",
              srcsets: [`${(De = (Be = (Ue = (He = (Ge = (Fe = (Ee = e.episode) == null ? void 0 : Ee.series) == null ? void 0 : Fe.image) == null ? void 0 : Ge.sizes) == null ? void 0 : He[0]) == null ? void 0 : Ue.srcSets) == null ? void 0 : Be[0]) == null ? void 0 : De.src} 1x`, `${(Ve = (Re = (Qe = (Me = (Ke = (Je = (Ie = e.episode) == null ? void 0 : Ie.series) == null ? void 0 : Je.image) == null ? void 0 : Ke.sizes) == null ? void 0 : Me[0]) == null ? void 0 : Qe.srcSets) == null ? void 0 : Re[1]) == null ? void 0 : Ve.src} 2x`]
            }
          ]
        }
      ) })
    ] })
  ] });
}
export {
  Ss as default
};
